import { store, useStudio } from '@/app/hooks';
import { AI_MODELS, CHAT_MODEL, hasApiKey } from './anthropic';

/**
 * AI is on when a parent/teacher/learner chose "Anthropic Claude" in Settings
 * and saved their own API key. Every AI feature falls back to Studio's local
 * version when AI is off or a request fails.
 */
export function aiReady(): boolean {
  return store.getState().settings.aiProvider === 'anthropic' && hasApiKey();
}

export function useAiReady(): boolean {
  const provider = useStudio((s) => s.settings.aiProvider);
  return provider === 'anthropic' && hasApiKey();
}

/** Analysis work (feedback, grading, courses, questions) uses the model chosen in Settings. */
export const analysisModel = () => store.getState().settings.aiModel;

/** Chat-style help uses Claude Haiku 5.5, like the study chat. */
export const tutorModel = () => CHAT_MODEL;

export const modelLabel = (id: string) => AI_MODELS.find((m) => m.id === id)?.label ?? id;
